import React, { useEffect, useRef, useState, useMemo } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import SingleSuspendPopup from '../../components/SingleSuspendPopup';
import MultipleSuspendPopup from '../../components/MultipleSuspendPopup';
import NoResults from '../../components/Noresults';
import AddNewAngel from '../../components/Angels/AddNewAngel';
import CustomDatePicker from '../../components/CustomDatePicker';
import Dropdown from '../../components/Dropdown/Dropdown';
import { DateInRange } from '../../utils/dateRange';
import { useStaticDataStore } from '../../stores/staticData';
import { ANGEL_PLAN, PAYMENT_PLAN, USER_PROFILE_PLAN } from '../../constants/common';
import { dateFormat, formattedDate } from '../../utils/formattedDate';
import { angelListApi } from '../../api/usersApi';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'
import angel from '../../assets/images/angel.png'

const SuspendedAngels = (props) => {
  const {
    setShowAddNewAngelPopup,
    setSelectAngel,
    isLoading,
    isLoadingData,
    angelList,
    totalPage,
    setEditAngel,
    setIsLoadingData,
    currentPage,
    setSearchQuery,
    searchQuery,
    setFilterAngel,
    filterAngel,
    setShowAngelSuspendPopup,
    setShowAngelMultipleSuspendPopup,
    selectedRows,
    setSelectedRows,
    isAllSelected,
    setIsAllSelected,
    toggleSelect,
    setErrorMessage,
    setCurrentPage,
    setReason,
    LazyImage,
    setAddAngelErrorMessage
  } = props

  const { data: staticData } = useStaticDataStore();
  const userIndustryRef = useRef();
  const userStartupStagesRef = useRef();
  const userAngelRef = useRef();
  const userDateRef = useRef();
  const userSuspendedDateRef = useRef();

  const industryTags = useMemo(() => {
    return staticData?.industryTags?.length ? staticData?.industryTags : [];
  }, [staticData?.industryTags]);

  const startupStages = useMemo(() => {
    return staticData?.startupStages?.length ? staticData?.startupStages : [];
  }, [staticData?.startupStages]);

  const angelPlan = ANGEL_PLAN;

  const [userIndustrySelect, setUserIndustrySelect] = useState(false)
  const [userStartupStagesSelect, setUserStartupStagesSelect] = useState(false)
  const [angelSelect, setAngelSelect] = useState(false)
  const [userDateSelect, setUserDateSelect] = useState(false)
  const [userSuspendedDateSelect, setSuspendedDateSelect] = useState(false)
  const [columnWidths, setColumnWidths] = useState([]);

  useEffect(() => {
    if (angelList?.length > 0) {
      calculateColumnWidths()?.then(() => {
        setTimeout(() => {
          setIsLoadingData(false);
        }, 1000);
      });
    }
  }, [angelList]);

  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(angelList?.map((row) => row?.userId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const handleDelete = async () => {
    if (selectedRows?.length === 1) {
      const selected = angelList?.find((row) => row?.userId === selectedRows[0]);
      if (selected) {
        setSelectAngel(selected);
      }
      setShowAngelSuspendPopup(true);
    }

    if (selectedRows?.length > 1) {
      setShowAngelMultipleSuspendPopup(true);
    }
    setErrorMessage('')
  };

  const handleEditClick = async (row) => {
    try {
      setEditAngel(true);
      setSelectAngel(row);
    } catch (error) {
      console.error('Failed to fetch user detail on edit:', error);
    }
  };

  const calculateColumnWidths = () => {
    return new Promise((resolve) => {
      const tempWidths = angelList?.reduce((acc, row) => {
        Object.keys(row)?.forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];

          let maxContentLength = 0;

          if (key === 'industryTags' || key === 'startupStages') {
            const categories = row[key];

            if (categories?.length > 1) {
              let tempCatLength = 0;

              for (let i = 0; i < 1; i++) {
                tempCatLength = tempCatLength + categories[i]?.length;
              }

              maxContentLength = Math?.max(tempCatLength, title?.length);

            } else {
              if (categories?.length == 0) {
                maxContentLength = Math?.max(dataValue?.length + 5);
              } else {
                maxContentLength = Math?.max(dataValue?.length + 3, title?.length);
              }
            }

          } else {
            maxContentLength = Math?.max(dataValue?.length, title?.length);
          }

          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});
      if (tempWidths !== undefined) {
        const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

          if (key === 'industryTags' || key === 'startupStages') {
            angelList?.forEach((row) => {
              const categoryWidth = tempWidths[key] * 10 + 40;
              acc[key] = `${categoryWidth}px`;
            });
          } else {
            acc[key] = `${tempWidths[key] * 10 + 40}px`;
          }
          return acc;
        }, {});

        setColumnWidths(widthMap);
      }
      resolve();
    });

  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '24px',
        color: '#666666'
      },
    },
  };

  const columns = [
    {
      name: 'Angel name',
      selector: (row) => row?.name,
      cell: (row) => {
        return <div className="angel-content angelTable" onClick={row?.status === 3 ? () => { handleEditClick(row); setReason(''); } : undefined}>
          <LazyImage
            src={row?.profileImg || avatar}
            alt="Suspended angel"
          />
          <div className="angel-brief">
            <span className="angel-name">
              {row?.name || 'NO NAME'}
            </span>
          </div>
        </div>
      },
      sortable: true,
      minWidth: columnWidths['name'] && `${parseInt(columnWidths['name']) + 55}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Email address',
      selector: (row) => row?.email,
      cell: (row) => {
        return <p className="user-mail">{row?.email}</p>
      },
      sortable: true,
      minWidth: columnWidths['email'] && (parseInt(columnWidths['email']) - 50 > 300) ? '300px' : `${parseInt(columnWidths['email']) - 10}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Industry',
      selector: (row) => row?.industryTags || staticData?.industryTags?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const industryTags = row?.industryTags?.length
          ? row?.industryTags
          : staticData?.industryTags?.map(item => item?.key) || [];

        const industry = industryTags?.slice(0, 1);
        const industryFull = industryTags?.slice(1);

        const getIndustryValue = (key) => {
          const found = staticData?.industryTags?.find(item => item?.key === key);
          return found ? found?.value : key;
        };

        return (
          <div className="industriesCategory">
            <div>
              {industry?.map((key, index) => (
                <span key={index}>{getIndustryValue(key)}</span>
              ))}
              {industryTags?.length > 1 && (
                <div className="industriesList">
                  <span>+{industryTags?.length - 1}</span>
                  <div className="industriesTooltip extraToolTip">
                    {industryFull?.map((key, idx) => (
                      <p key={idx}>{getIndustryValue(key)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) + 40}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['industryTags'] && `${parseInt(columnWidths['industryTags']) - 10}px`, lineHeight: '20px' },
    },
    {
      name: 'Startup stage',
      selector: (row) => row?.startupStages || staticData?.startupStages?.map(item => item?.key),
      sortable: false,
      cell: (row) => {
        const startupStages = row?.startupStages?.length
          ? row?.startupStages
          : staticData?.startupStages?.map(item => item?.key) || [];

        const startupStage = startupStages?.slice(0, 1);
        const startupStageFull = startupStages?.slice(1);

        const getStartupStageValue = (key) => {
          const found = staticData?.startupStages?.find(item => item?.key === key);
          return found ? found?.value : key;
        };
        return (
          <div className="industriesCategory">
            <div>
              {startupStage?.map((item, index) => (
                <span key={index}>{getStartupStageValue(item)}</span>
              ))}

              {startupStages?.length > 1 && (
                <div className="industriesList">
                  <span>+{startupStages?.length - 1}</span>
                  <div className="industriesTooltip">
                    {startupStageFull?.map((item, idx) => (
                      <p key={idx}>{getStartupStageValue(item)}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
      paddingLeft: 0,
      width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 65}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['startupStages'] && `${parseInt(columnWidths['startupStages']) + 40}px`, fontSize: "12px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.24px' },
    },
    {
      name: 'Plan',
      selector: (row) => row?.plan,
      sortable: true,
      cell: (row) => {
        const matched = angelPlan?.find((plan) => plan?.key === row?.plan);
        return (
          row?.plan?.trim() ? (
            <div className='industriesCategory'>
              <div>
                <span>{matched?.value}</span>
              </div>
            </div>
          ) : null
        );
      },
      paddingLeft: 0,
      width: columnWidths['plan'] && `${parseInt(columnWidths['plan']) - 170}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "12px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.24px' },
    },
    {
      name: 'Date registered',
      selector: (row) => row?.registeredAt,
      cell: (row) => {
        return <p>{formattedDate(row?.registeredAt)}</p>
      },
      sortable: true,
      width: columnWidths['registeredAt'] && `${parseInt(columnWidths['registeredAt']) - 110}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Date suspended',
      selector: (row) => row?.suspendedAt,
      cell: (row) => {
        return <p>{formattedDate(row?.suspendedAt || row?.registeredAt)}</p>
      },
      sortable: true,
      width: columnWidths['suspendedAt'] && `${parseInt(columnWidths['suspendedAt']) - 140}px`,
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <>
            {
              row?.status === 3 &&
              <div className='table-actions'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setShowAngelSuspendPopup(true); setSelectAngel(row); setErrorMessage(''); }}>
                  <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            }
          </>
        )
      },
      justifyContent: 'flex-end',
      allowOverflow: true,
      button: true,
      minWidth: "55px",
      paddingRight: '16px',
      width: '70px',
      style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
    },
  ]

  return (
    <div className='active-angels'>
      <div className='active-angel-top'>
        <div className='pagesSearch twoItemWrap'>
          <div className="pageSearchInput">
            <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search suspended angels...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            <img src={search} alt="Search" />
          </div>

          <Dropdown
            ref={userIndustryRef}
            selectedDropdown={userIndustrySelect}
            setSelectedDropdown={setUserIndustrySelect}
            items={industryTags}
            setSelectedValue={(val) => {
              setFilterAngel(prev => ({
                ...prev,
                industry: val
              }));
            }}
            selectedValue={filterAngel?.industry}
            name={"Industry"}
          />


          <Dropdown
            ref={userStartupStagesRef}
            selectedDropdown={userStartupStagesSelect}
            setSelectedDropdown={setUserStartupStagesSelect}
            items={startupStages}
            setSelectedValue={(val) => {
              setFilterAngel(prev => ({
                ...prev,
                startupStage: val
              }));
            }}
            selectedValue={filterAngel?.startupStage}
            name={"Startup stage"}
          />

          <Dropdown
            ref={userAngelRef}
            selectedDropdown={angelSelect}
            setSelectedDropdown={setAngelSelect}
            items={angelPlan}
            setSelectedValue={(val) => {
              setFilterAngel(prev => ({
                ...prev,
                plan: val
              }));
            }}
            selectedValue={filterAngel?.plan}
            name={"Plan"}
          />


          <CustomDatePicker
            onApply={(dateRange) => {
              setFilterAngel(prev => ({
                ...prev,
                registedDate: dateRange
              }));
              setUserDateSelect(false);
            }}
            selectedDate={filterAngel?.registedDate}
            onCancel={() => setUserDateSelect(false)}
            isSelectDate={userDateSelect}
            ref={userDateRef}
            setSelectDate={setUserDateSelect}
            label={"Date registered"}
          />

          <CustomDatePicker
            onApply={(dateRange) => {
              setFilterAngel(prev => ({
                ...prev,
                suspendedDate: dateRange
              }));
              setSuspendedDateSelect(false);
            }}
            selectedDate={filterAngel?.suspendedDate}
            onCancel={() => setSuspendedDateSelect(false)}
            isSelectDate={userSuspendedDateSelect}
            ref={userSuspendedDateRef}
            setSelectDate={setSuspendedDateSelect}
            label={"Date suspended"}
          />

        </div>
        <div className='new-angel'>
          {selectedRows?.length > 0 &&
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { handleDelete(); setReason(''); }}>
              <path d="M1.5 7.5C1.5 7.5 3.00374 5.45116 4.22538 4.22868C5.44702 3.0062 7.1352 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.92268 15.75 3.32633 13.6907 2.51382 10.875M1.5 7.5V3M1.5 7.5H6" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          }
          <button className='new-angel-button' onClick={() => { setShowAddNewAngelPopup(true); setAddAngelErrorMessage({ name: '', email: '' }) }}>New Angel</button>
        </div>
      </div>
      <div className='table-pagination-wrapper angel-list'>
        <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
          <DataTableList
            data={angelList}
            columns={columns}
            customStyles={customStyles}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            currentPage={currentPage}
            selectableRowsComponent="input"
            selectableRows={true}
            selectAllRows={isAllSelected}
            onSelectAllChange={handleMasterCheckboxChange}
            clearSelectedRows={toggleSelect}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows?.map((row) => row?.userId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds?.length === angelList?.length);
            }}
            selectableRowDisabled={(row) => row?.status !== 3}
            progressPending={isLoading}
            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
            noDataComponent={<NoResults title='No suspended angels' description="Looks like no angels have been suspended - that's a good sign! Everyone’s playing nice for now, but if anything changes, you’ll see it here." image={angel} />}
          />
        </div>
      </div>
    </div>
  )
}

export default SuspendedAngels
